import { TextareaHTMLAttributes, forwardRef } from 'react';
import clsx from 'clsx';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...rest }, ref) => {
  return (
    <textarea
      ref={ref}
      className={clsx(
        'w-full rounded-lg border border-edge bg-elevated px-3 py-2 text-sm text-body placeholder:text-faint',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className,
      )}
      {...rest}
    />
  );
});

Textarea.displayName = 'Textarea';
